import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#0a0b0e] border border-[#262a33] rounded-xl px-4 py-3 text-white placeholder:text-[#64697a] outline-none focus:ring-2 focus:ring-[#00e676]";

  return (
    <div className="min-h-screen bg-[#0a0b0e] flex items-center justify-center px-5">
      <div className="w-full max-w-sm bg-[#161920] border border-[#262a33] rounded-2xl p-7">
        <Link to="/admin/login" className="flex items-center gap-1 text-[#a0a5b5] text-sm mb-5 hover:text-white"><ArrowLeft className="w-4 h-4" /> Retour</Link>
        <h1 className="font-display text-xl font-bold text-white mb-1">Mot de passe oublié</h1>
        <p className="text-[#64697a] text-sm mb-5">Nous générerons un lien de réinitialisation.</p>
        {sent ? (
          <p className="text-[#00e676] text-sm" data-testid="forgot-sent">Si cet e-mail existe, un lien a été généré (voir les logs serveur).</p>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
            <button disabled={loading} className="w-full bg-[#00e676] hover:bg-[#00c853] text-[#04120a] font-bold rounded-full py-3 flex items-center justify-center transition-colors disabled:opacity-60" data-testid="forgot-submit">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Envoyer le lien"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
